import "./categoryForm.css";
import { useState } from 'react';
import { useCreateCategoryMutation, useGetAllCategoriesQuery } from '../../services/productApi'
import { useNavigate } from "react-router-dom";
import { AdminPageHeader, AdminCard, AdminInput, AdminTextarea, AdminSelect, LoadingButton, useToast } from '../../components/ui'

const NewCategory = () => {
  const navigate = useNavigate();
  const [server_error, setServerError] = useState({})
  const [createCategory, { isLoading }] = useCreateCategoryMutation()
  const { data: categories } = useGetAllCategoriesQuery()
  const toast = useToast();

  const handleSubmit = async (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    const actualData = {
      name: data.get("name"),
      description: data.get("description"),
      parent: data.get("parent") || null,
      is_active: data.get("is_active") === "on",
    };

    const res = await createCategory(actualData);
    if (res.error) {
      setServerError(res.error.data?.errors || {});
      toast.error("Could not create this category. Check the fields below.");
    }
    if (res.data) {
      toast.success("Category added successfully.");
      setTimeout(() => navigate('/admin/categories'), 1200);
    }
  };

  return (
    <div>
      <AdminPageHeader
        title="New Category"
        breadcrumbs={[{ label: "Dashboard", to: "/admin/dashboard" }, { label: "Categories", to: "/admin/categories" }, { label: "New" }]}
      />
      <AdminCard className="categoryForm">
        <form onSubmit={handleSubmit}>
          <AdminInput label="Name" name="name" placeholder="e.g. Baking Ingredients" error={server_error.name?.[0]} required />
          <AdminTextarea label="Description" name="description" placeholder="Optional description" rows={4} error={server_error.description?.[0]} />
          <AdminSelect label="Parent Category (optional)" name="parent" defaultValue="" error={server_error.parent?.[0]}>
            <option value="">No parent - top level</option>
            {(categories || []).map((c) => (
              <option key={c.id} value={c.id}>{c.name}</option>
            ))}
          </AdminSelect>
          <label className="categoryForm__checkbox">
            <input type="checkbox" name="is_active" defaultChecked /> Active (visible to customers)
          </label>
          <div className="categoryForm__actions">
            <LoadingButton type="submit" loading={isLoading} loadingLabel="Creating...">Create Category</LoadingButton>
          </div>
        </form>
      </AdminCard>
    </div>
  );
}

export default NewCategory
